import _defineProperty from "/workdir/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PHABLET_BREAKPOINT = 704;

class ShowMore extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      hasClicked: false,
      minItems: this.props.minItems,
      // eslint-disable-next-line no-magic-numbers
      mobileMinItems: this.props.minItems - this.props.minItems % 2
    });

    _defineProperty(this, "showAll", () => {
      this.setState({
        hasClicked: true
      });
    });

    _defineProperty(this, "updateMinItems", () => {
      const {
        mobileMinItems,
        minItems
      } = this.state;

      if (window.innerWidth < PHABLET_BREAKPOINT && minItems !== mobileMinItems) {
        this.setState({
          minItems: mobileMinItems
        });
      } else if (window.innerWidth >= PHABLET_BREAKPOINT && this.props.minItems !== minItems) {
        this.setState({
          minItems: this.props.minItems
        });
      }
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateMinItems);
    this.updateMinItems();
  }

  componentDidUpdate() {
    if (this.props.minItems !== this.state.minItems) {
      this.updateMinItems();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateMinItems);
  }

  render() {
    const {
      children,
      buttonText
    } = this.props;
    const {
      minItems,
      hasClicked
    } = this.state;
    const items = hasClicked && children ? children.length : minItems;
    return (
      /*#__PURE__*/
      // Need to check minItems props here to ensure the parent component  needs to use it
      _jsxs(_Fragment, {
        children: [minItems ? children.slice(0, items) : children, minItems && !hasClicked && children.length >= items &&
        /*#__PURE__*/
        // Hide the button if there are less children than minItems
        _jsx("div", {
          className: style.showMoreWrapper,
          children: /*#__PURE__*/_jsx("button", {
            className: style.callToActionLink,
            onClick: e => {
              e.preventDefault();
              this.showAll();
            },
            children: buttonText
          })
        })]
      })
    );
  }

}

_defineProperty(ShowMore, "defaultProps", {
  minItems: 0,
  buttonText: 'See more',
  buttonFullWithOnMobile: false
});

export default ShowMore;